import {getApiBaseUrl} from "@helpers/appSettings/appSettings";

export const IS_SEPARATED = __IS_SEPARATED__ as boolean;
const isDev = process.env.NODE_ENV === "development";
export const BASE_TRACK_API_URL = getApiBaseUrl()
// For local:
// export const BASE_TRACK_API_URL = 'http://localhost:8080'
export const SEARCH_SERVICE_TRACK_API_URL = 'https://search-bridge.ua-gis.com/api'
export const GIS_BOARDS_API_URL = 'https://ua-gis.com/gis-tablo-api'
export const GIS_BOARDS_REQUEST_URL = 'https://panel.tromvo.net'
export const NOMINATIM_API_URL = 'https://nominatim.ua-gis.com'

export const ROOT_PATH = IS_SEPARATED ? '/' : '/iTrack/app/'
export const TRACK_PATH = '/iTrack'
// The one page open without signing in. track1 sends the browser here with ?returnUrl=...
export const LOGIN_PATH = `${ROOT_PATH}login`
export const TRACK_ORIGIN = 'https://track.ua-gis.com'

export const TRACK_IMAGE_PATH = '/images/auto'

export const GRAPHHOPPER_API_URL = isDev ? 'http://157.90.40.12:8919' : 'https://graphhopper.ua-gis.com'


